// Material Kit 2 React pages
import Clinics from "pages/LandingPages/Clinics";

export default function ClinicsPage() {
  return <Clinics />;
}
